import {
  GET_ALL_DAMAGE_RECEIPT_REQUEST,
  GET_ALL_DAMAGE_RECEIPT_SUCCESS,
  GET_ALL_DAMAGE_RECEIPT_ERROR,
  GET_ONE_DAMAGE_RECEIPT_HEADER_REQUEST,
  GET_ONE_DAMAGE_RECEIPT_HEADER_SUCCESS,
  GET_ONE_DAMAGE_RECEIPT_HEADER_ERROR,
  GET_ONE_DAMAGE_RECEIPT_HEADER_DETAIL_REQUEST,
  GET_ONE_DAMAGE_RECEIPT_HEADER_DETAIL_SUCCESS,
  GET_ONE_DAMAGE_RECEIPT_HEADER_DETAIL_ERROR,
  DELETE_DAMAGE_RECEIPT_HEADER_REQUEST,
  DELETE_DAMAGE_RECEIPT_HEADER_SUCCESS,
  DELETE_DAMAGE_RECEIPT_HEADER_ERROR,
  ADD_DAMAGE_RECEIPT_HEADER_REQUEST,
  ADD_DAMAGE_RECEIPT_HEADER_SUCCESS,
  ADD_DAMAGE_RECEIPT_HEADER_ERROR,
  UPDATE_DAMAGE_RECEIPT_HEADER_REQUEST,
  UPDATE_DAMAGE_RECEIPT_HEADER_SUCCESS,
  UPDATE_DAMAGE_RECEIPT_HEADER_ERROR,
  GET_DAMAGE_RECEIPT_SUMMARY_REQUEST,
  GET_DAMAGE_RECEIPT_SUMMARY_SUCCESS,
  GET_DAMAGE_RECEIPT_SUMMARY_ERROR,
  GET_DAMAGE_RECEIPT_DETAIL_REQUEST,
  GET_DAMAGE_RECEIPT_DETAIL_SUCCESS,
  GET_DAMAGE_RECEIPT_DETAIL_ERROR,
  CREATE_DAMAGE_RECEIPT_LINES_FILES_REQUEST,
  CREATE_DAMAGE_RECEIPT_LINES_FILES_SUCCESS,
  CREATE_DAMAGE_RECEIPT_LINES_FILES_ERROR,
  DELETE_DAMAGE_RECEIPT_LINES_FILES_REQUEST,
  DELETE_DAMAGE_RECEIPT_LINES_FILES_SUCCESS,
  DELETE_DAMAGE_RECEIPT_LINES_FILES_ERROR,
} from "./types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");

export const addDamageReceiptHeader = (token, formData, dbData) => (dispatch) => {
  dispatch({ type: ADD_DAMAGE_RECEIPT_HEADER_REQUEST });
  let newData = {
    damage_date: moment(formData.damageDate).format("MM-DD-YYYY"),
    return_header_id: dbData.return_header_id,
    invoice_header_id: dbData.invoice_header_id,
    ship_header_id: dbData.ship_header_id,
    order_header_id: dbData.order_header_id,
    gl_period_id: dbData.gl_period_id,
    customer_id: dbData.customer_id,
    company_id: dbData.company_id,
    gl_period_id: formData.postingPeriod,
    asn_no: formData.asnNo,
    memo: formData.memo,
    location_id: formData?.location,
    return_header_no: formData?.RaNumber,
    receipt_remarks: formData.receipt_remarks === undefined ? null : formData.receipt_remarks,
    return_label_fee: formData.return_label_fee === undefined ? 0 : formData.return_label_fee,
    receiving_status: formData.receiving_status === undefined ? null : formData.receiving_status,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}create/damageReceiptHeader`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: ADD_DAMAGE_RECEIPT_HEADER_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: ADD_DAMAGE_RECEIPT_HEADER_ERROR,
        payload: error.response,
      });
    });
};

export const updateDamageReceiptHeader = (token, formData, dbData) => (dispatch) => {

  let newData = {
    damage_date: moment(formData?.damageDate).format("MM-DD-YYYY"),
    return_header_id: dbData?.return_header_id,
    invoice_header_id: dbData?.invoice_header_id,
    ship_header_id: dbData?.ship_header_id,
    order_header_id: dbData?.order_header_id,
    gl_period_id: dbData?.gl_period_id,
    customer_id: dbData?.customer_id,
    company_id: dbData?.company_id,
    gl_period_id: formData?.postingPeriod,
    asn_no: formData?.asnNo,
    memo: formData?.memo,
    location_id: formData?.location,
    receipt_remarks: formData.receipt_remarks,
    return_label_fee: formData.return_label_fee,
    receiving_status: formData.receiving_status,
  };
  dispatch({ type: UPDATE_DAMAGE_RECEIPT_HEADER_REQUEST });
  return axios({
    method: "PUT",
    url: `${BASEURL}update/damageReceiptHeader/${formData?.damageHeaderId}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {

      return dispatch({
        type: UPDATE_DAMAGE_RECEIPT_HEADER_SUCCESS,
        payloadUpdate: response?.data?.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: UPDATE_DAMAGE_RECEIPT_HEADER_ERROR,
        payloadUpdate: error.response,
      });
    });
};

export const getAllDamageReceiptHeader = (token, data) => (dispatch) => {

  dispatch({ type: GET_ALL_DAMAGE_RECEIPT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/damageReceiptHeader`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      from_date: moment(data.from_date).format("MM-DD-YYYY"),
      to_date: moment(data.to_date).format("MM-DD-YYYY"),
      damage_header_no: data.damageNo === "" ? null : data.damageNo,
      return_header_no: data.returnNo === "" ? null : data.returnNo,
      note_header_no: data.CNno === "" ? null : data.CNno,
      gl_period_name: data.postingPeriod === "" ? null : data.postingPeriod,
      customer_name: data.customerName === "" ? null : data.customerName,
      invoice_header_no: data.InvoiceNo === "" ? null : data.InvoiceNo,
      ra_no: data.raNo === "" ? null : data.raNo,
      lot_no: data.lotNo === "" ? null : data.lotNo,
      receiving_status: data.receiving_status,
    },

  })
    .then((response) => {
      return dispatch({
        type: GET_ALL_DAMAGE_RECEIPT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_ALL_DAMAGE_RECEIPT_ERROR,
        payload: error.response,
      });
    });
};

export const getOneDamageReceiptHeaderDetail = (token, id) => (dispatch) => {
  dispatch({ type: GET_ONE_DAMAGE_RECEIPT_HEADER_REQUEST });
  return axios({
    method: "GET",
    url: `${BASEURL}getOne/damageReceiptHeaderDetail/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_ONE_DAMAGE_RECEIPT_HEADER_SUCCESS,
        payload: response?.data[0],
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_ONE_DAMAGE_RECEIPT_HEADER_ERROR,
        payload: error.response,
      });
    });
};

export const getOneDamageReceiptHeader = (token, id) => (dispatch) => {
  dispatch({ type: GET_ONE_DAMAGE_RECEIPT_HEADER_DETAIL_REQUEST });
  return axios({
    method: "GET",
    url: `${BASEURL}getOne/damageReceiptHeader/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_ONE_DAMAGE_RECEIPT_HEADER_DETAIL_SUCCESS,
        payload: response?.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_ONE_DAMAGE_RECEIPT_HEADER_DETAIL_ERROR,
        payload: error.response,
      });
    });
};

export const deleteDamageReceiptHeader = (token, id) => (dispatch) => {
  dispatch({ type: DELETE_DAMAGE_RECEIPT_HEADER_REQUEST });
  return axios({
    method: "DELETE",
    url: `${BASEURL}delete/damageReceiptHeader/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: DELETE_DAMAGE_RECEIPT_HEADER_SUCCESS,
        payload: response?.data.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: DELETE_DAMAGE_RECEIPT_HEADER_ERROR,
        payload: error.response,
      });
    });
};


export const getDamageReceiptSummary = (token, values) => (dispatch) => {
  dispatch({
    type: GET_DAMAGE_RECEIPT_SUMMARY_REQUEST
  });
  const newData = {
    customer_cat_id: values.cutomer_category === "All" || values.cutomer_category === undefined ? null : values.cutomer_category,
    date_from: moment(values.from_date).format("MM-DD-YYYY"),
    date_to: moment(values.to_date).format("MM-DD-YYYY"),
    damage_header_no: values.Damage_no === undefined || values.Damage_no === "" ? null : values.Damage_no,
    return_header_no: values.return_header_no === undefined || values.return_header_no === "" ? null : values.return_header_no,
    invoice_header_no: values.invoice_header_no === undefined || values.invoice_header_no === "" ? null : values.invoice_header_no,
    ship_header_no: values.ship_header_no === undefined || values.ship_header_no === "" ? null : values.ship_header_no,
    ra_aproval: values.ra_aproval === undefined || values.ra_aproval === "" ? null : values.ra_aproval,
    asn_no: values.asn_no === undefined || values.asn_no === "" ? null : values.asn_no,
    reference_no: values.po_no === undefined || values.po_no === "" ? null : values.po_no,
    customer: values.customer === undefined || values.customer === "" ? null : values.customer,
    bill_addressee: values.billing_addressee === undefined || values.billing_addressee === "" ? null : values.billing_addressee,
    sid: values.sale_person === "All" || values.sale_person === undefined ? null : values.sale_person,
    region_id: values.region === undefined || values.region === "All" ? null : values.region.toString(),
    gender_id: values.gender === "All" || values.gender === undefined ? null : values.gender,
    payment_term_id: values.terms === "All" || values.terms === undefined ? null : values.terms,
    company_id: values.subsidary === "All" || values.subsidary === undefined ? null : values.subsidary,
    sku: values.sku === undefined || values.sku === "" ? null : values.sku,
    location_id: values.location === undefined || values.location === "All" ? null : values.location,
    ntype: null,
    customer_id: values.customerNew === undefined ? null : values.customerNew,
    receiving_status: values.receiving_status === "All" || values.receiving_status === undefined ? null : values.receiving_status,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/damageReceiptSummary`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  }).then((response) => {
    return dispatch({
      type: GET_DAMAGE_RECEIPT_SUMMARY_SUCCESS,
      payload: response.data,
    });
  }).catch((error) => {
    dispatch({
      type: GET_DAMAGE_RECEIPT_SUMMARY_ERROR,
      payload: [],
    });
  });
};

export const getDamageReceiptDetail = (token, values) => (dispatch) => {
  dispatch({ type: GET_DAMAGE_RECEIPT_DETAIL_REQUEST });

  const newData = {
    customer_cat_id: values.cutomer_category === "All" ? null : values.cutomer_category,
    date_from: moment(values.from_date).format("MM-DD-YYYY"),
    date_to: moment(values.to_date).format("MM-DD-YYYY"),
    damage_header_no: values.damage_no === undefined || values.damage_no === "" ? null : values.damage_no,
    memo_header_no: values.credit_memo_no === undefined || values.credit_memo_no === "" ? null : values.credit_memo_no,
    return_header_no: values.return_header_no === undefined || values.return_header_no === "" ? null : values.return_header_no,
    invoice_header_no: values.invoice_header_no === undefined || values.invoice_header_no === "" ? null : values.invoice_header_no,
    ship_header_no: values.ship_header_no === undefined || values.ship_header_no === "" ? null : values.ship_header_no,
    reference_no: values.po_no === undefined || values.po_no === "" ? null : values.po_no,
    customer: values.customer === undefined || values.customer === "" ? null : values.customer,
    billcustomer: values.billing_addressee === undefined || values.billing_addressee === "" ? null : values.billing_addressee,
    sp_id: values.sale_person === "All" ? null : values.sale_person,
    region_id: values.region === undefined || values.region === "All" ? null : values.region.toString(),
    gender_id: values.gender === "All" ? null : values.gender,
    payment_term_id: values.terms === "All" ? null : values.terms,
    company_id: values.subsidary === "All" ? null : values.subsidary,
    sku: values.sku === undefined || values.sku === "" ? null : values.sku,
    location_id: values.location === undefined || values.location === "All" ? null : values.location,
    lot_no: values.asn_no === undefined ? null : values.asn_no,
    ra_no: values.ra_aproval === undefined ? null : values.ra_aproval,
    ntype: null,
    order_header_no: null,
    store_id: null,
    source_type: null,
    status: null,
    receiving_status: values.receiving_status === "All" || values.receiving_status === undefined ? null : values.receiving_status,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/damageReceiptDetail`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_DAMAGE_RECEIPT_DETAIL_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DAMAGE_RECEIPT_DETAIL_ERROR,
        payload: [],
      });
    });
};

export const createDamageRecieptUpload = (
  token,
  file,
  damage_line_id,
  remarks,
) => (dispatch) => {

  dispatch({ type: CREATE_DAMAGE_RECEIPT_LINES_FILES_REQUEST });
  console.log("remarks", remarks)
  let data = new FormData();
  data.append('file', file);
  data.append('remarks', remarks);
  data.append('damage_line_id', damage_line_id);



  return axios({
    method: "POST",
    url: `${BASEURL}uploads/damageReceiptLineFile/${damage_line_id}`,
    data: data,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data"
    },
  })
    .then((response) => {

      return dispatch({ type: CREATE_DAMAGE_RECEIPT_LINES_FILES_SUCCESS, payload: response.data });
    })
    .catch((error) => {

      return dispatch({
        type: CREATE_DAMAGE_RECEIPT_LINES_FILES_ERROR,
        payload: error.response,
      });
    });
};

export const deleteDamageRecieptUpload = (token, id) => (dispatch) => {
  dispatch({ type: DELETE_DAMAGE_RECEIPT_LINES_FILES_REQUEST });
  return axios({
    method: "DELETE",
    url: `${BASEURL}delete/damageReceiptLineFileDelete/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: DELETE_DAMAGE_RECEIPT_LINES_FILES_SUCCESS,
        payload: response?.data.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: DELETE_DAMAGE_RECEIPT_LINES_FILES_ERROR,
        payload: error.response,
      });
    });
};